import React from 'react';
import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { SimpleModal } from '@livable/saas-react-components';
import { UpdatePaymentMethodModalContent } from './content';
export const UpdatePaymentMethodModal = observer(_ref => {
  let id = _ref.id;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(SimpleModal, {
    trigger: /*#__PURE__*/React.createElement(Button, {
      variant: "priority",
      'custom-attribute': '305-StripeForm'
    }, "Update Payment Method"),
    title: t('Update payment Method'),
    noFooter: true
  }, /*#__PURE__*/React.createElement(UpdatePaymentMethodModalContent, {
    paymentId: id
  }));
});